import axios, { AxiosInstance } from 'axios';
import Applications from './applications';
import Feedback from './feedback';
import Jobs from './jobs';
import Reviews from './reviews';
import Stats from './stats';
import Users from './users';

export interface IPaginationParams {
  until?: string;
  since?: string;
  limit?: number;
  orderBy?: string;
  orderDirection?: 'ASC' | 'DESC';
}

export interface IPaginationMetaResponse {
  has_next: boolean;
  has_previous: boolean;
}

class QuickJobsApi {
  public httpClient: AxiosInstance;

  public feedback: Feedback;
  public jobs: Jobs;
  public stats: Stats;
  public reviews: Reviews;
  public users: Users;
  public applications: Applications;

  private clientId: string;
  private clientSecret: string;
  private accessToken: string | null = null;

  constructor(url: string, clientId: string, clientSecret: string) {
    this.httpClient = axios.create({
      baseURL: url + '/api/v2/',
    });
    this.clientId = clientId;
    this.clientSecret = clientSecret;

    this.feedback = new Feedback(this);
    this.jobs = new Jobs(this);
    this.stats = new Stats(this);
    this.reviews = new Reviews(this);
    this.users = new Users(this);
    this.applications = new Applications(this);
  }

  public async login(
    phone: string,
    password: string
  ): Promise<{ access_token: string; expires_in: string }> {
    const tokenResponse = await this.httpClient.post(
      '/oauth/token',
      {
        grant_type: 'password',
        username: phone,
        password: password,
        scope: 'user_identity',
      },
      {
        headers: {
          Authorization: `Basic ${this.getClientToken()}`,
        },
      }
    );
    if (tokenResponse.status !== 200) {
      throw new Error(`Server returned status ${tokenResponse.status}`);
    }
    this.setAccessToken(tokenResponse.data.access_token);
    return tokenResponse.data;
  }

  public changePassword(oldPassword: string, newPassword: string) {
    return this.httpClient.patch('/me/password', {
      old_password: oldPassword,
      new_password: newPassword,
    });
  }

  public getMe() {
    return this.httpClient.get('/me');
  }

  public getClientToken() {
    return Buffer.from(`${this.clientId}:${this.clientSecret}`).toString('base64');
  }

  public getAccessToken() {
    return this.accessToken;
  }

  public setAccessToken(token: string) {
    this.accessToken = token;
    this.httpClient.defaults.headers.common.Authorization = `Bearer ${this.getAccessToken()}`;
    return this;
  }
}

export default QuickJobsApi;



// WEBPACK FOOTER //
// ./src/libs/quickjobs-api/index.ts